import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NriMembersListComponent } from './nri-cities/nri-members-list.component';
const routes: Routes = [
  { path: '', component: NriMembersListComponent },
  { path: 'nri-memberlist', component: NriMembersListComponent }
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NriRoutingModule { }